import {
  carStatusValues,
  incomeSourceValues,
  LoanFormValues,
  noIncomeEmploymentOptions,
} from '../model/formState';
import { Dayjs } from 'dayjs';
import { useState } from 'react';
import finelfApi from '../model/finelfApi';
import { IAgreement } from '../model/IAgreement';

export const REDIRECT_INTERVAL = 180;
export const REDIRECT_ATTEMPTS = 1;
export const FALLBACK_URL = '/';
const DEFAULT_PARTNER = '50a7643d36b74919053217e029fb4856';

const searchParams = new URLSearchParams(window.location.search);

const partnerUnescaped =
  searchParams.get('partnerToken') ||
  searchParams.get('partner_token') ||
  searchParams.get('partner') ||
  DEFAULT_PARTNER;

export const logoURL = searchParams.get('logo') || '';

export const partner = partnerUnescaped.replaceAll('%2F', '').replaceAll('/', '');

export function useLoanForm({ agreements }) {
  const [openEmailValidatingModal, setOpenEmailValidatingModal] = useState<boolean>(false);
  const [openFinishModal, setOpenFinishModal] = useState<boolean>(false);
  const [statusUrl, setStatusUrl] = useState<string>('');

  const clickId = searchParams.get('click_id');
  const affSub = searchParams.get('aff_sub');

  const transactionId = searchParams.get('transaction_id');

  const onSubmit = async (formState) => {
    setOpenFinishModal(true);

    const { values, maskedValues } = formState;

    const {
      basicInformation,
      personalInformation,
      addressInformation,
      financeInformation,
      employeeInformation,
    } = values as LoanFormValues;
    const { beforeAgreements, agreements: checkedAgreements } = basicInformation || {};

    const data: { [key: string]: any } = {
      //basic
      base_phone: beforeAgreements.phone_mobile,
      base_email: beforeAgreements.email,
      base_pesel: beforeAgreements.pesel,
      credit_target: beforeAgreements.loan_reason,

      //personal
      base_name: personalInformation.first_name,
      base_last_name: personalInformation.last_name,
      /*gender: personalInformation.gender,
            date_of_birth: (personalInformation.date_of_birth as Dayjs).format('YYYY-MM-DD'),*/
      extended_id_card: personalInformation.id_code,
      extended_id_card_issue_date: (personalInformation.id_card_number_issued as Dayjs).format(
        'YYYY-MM-DD',
      ),
      extended_marital_status: personalInformation.marital_status,
      home_dependants_count: personalInformation.amount_of_children,

      //address
      address_city: addressInformation.text_city,
      address_postcode: addressInformation.text_zip,
      address_street: addressInformation.street,
      address_building: addressInformation.house_number,
      home_property_ownership: addressInformation.home_property_ownership,
      home_property_type: addressInformation.home_property_type,
      home_property_residency_start_date: (
        addressInformation.home_property_residency_start_date as Dayjs
      ).format('YYYY-MM-DD'),

      //financial
      //globals scrapped at the last step
      credit_value: Number(financeInformation.amount),
      credit_time: Number(financeInformation.period) * 30,

      extended_education: financeInformation.education,
      income_source: financeInformation.income_source,
      income_value: financeInformation.income || 0,
      home_income_value: financeInformation.home_income_value || 0,
      home_monthly_expenses: financeInformation.home_monthly_expenses || 0,
      home_owns_car: financeInformation.car_status === carStatusValues.YES,
      account_number: financeInformation.bank_account_number,

      user_agent: window.navigator.userAgent,

      ...(partner && { partner_token: partner }),
      ...(affSub && { tune_affiliate_info1: affSub }),
      ...(clickId && { external_id: clickId }),
      ...(transactionId && { tune_transaction_id: transactionId }),
    };

    // if (addressInformation.apartment_number) {
    //   data.address_flat = addressInformation.apartment_number;
    // }
    data.extended_has_debt = '0';

    if (carStatusValues.YES === financeInformation.car_status) {
      data.car_plates = financeInformation.license_plate_number;
    }

    if (!noIncomeEmploymentOptions.includes(data.income_source)) {
      data.work_tax_number = employeeInformation?.employee_nip;
      data.work_address_postcode = employeeInformation?.employee_zip;
      data.work_address_city = employeeInformation?.employee_city;
      data.work_address_street = employeeInformation?.employee_street;
      data.work_income_area = employeeInformation?.industry;
      data.work_position = employeeInformation?.occupation;

      if (
        ![incomeSourceValues.AGRICULTURE, incomeSourceValues.SELF_EMPLOYED].includes(
          data.income_source,
        )
      ) {
        data.income_start_date = (employeeInformation?.work_seniority as Dayjs)?.format(
          'YYYY-MM-DD',
        );
      }

      if (employeeInformation?.work_company_name) {
        data.work_company_name = employeeInformation.work_company_name;
      }
    }

    agreements.forEach((agreement: IAgreement) => {
      data[`agree_(${agreement.id})`] = checkedAgreements.some((id) => id === agreement.id);
    });

    try {
      const body = {
        ...data,
        agreements: checkedAgreements,
      };

      const response = await fetch(`${finelfApi.apiUrl}${finelfApi.dataUri}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();
      const { ok, status_url } = json;
      console.log('🚀 ~ onSubmit ~ status_url:', status_url);
      if (status_url) {
        setStatusUrl(status_url);
      }

      // if (Number(ok) === 1) {
      //   let availableAttempts = 20;

      //   const checkLoanGranted = async () => {
      //     // const url = `${finelfApi.apiUrl}/v1/check-lead-target-status?ct=${ct}&o=${o}`;
      //     const response = await fetch(status_url);
      //     const { next_request_status, redirect_url } = await response.json();

      //     if (redirect_url) {
      //       window.location.replace(redirect_url);
      //     } else if (next_request_status === 'stop' || availableAttempts === 0) {
      //       window.location.replace(FALLBACK_URL);
      //       clearInterval(checkLoanInterval);
      //     }

      //     availableAttempts--;
      //   };

      //   const checkLoanInterval = setInterval(checkLoanGranted, 5000);
      // } else {
      //   window.location.replace(FALLBACK_URL);
      // }
    } catch (e) {
      console.log(e);

      // window.location.replace(FALLBACK_URL);
    }
  };

  return {
    openEmailValidatingModal,
    openFinishModal,
    onSubmit,
    statusUrl,
  };
}
